import { ChecklistItem } from "./checklist-item";
import { ChecklistCategory } from "./checklist-category";

export class ChecklistCategoryItem {
  category: ChecklistCategory;
  items: ChecklistItem[];
}
